import { render, staticRenderFns } from "./DfTelephoneField.vue?vue&type=template&id=09a6c8aa&scoped=true&"
import script from "./DfTelephoneField.vue?vue&type=script&lang=js&"
export * from "./DfTelephoneField.vue?vue&type=script&lang=js&"
import style0 from "./DfTelephoneField.vue?vue&type=style&index=0&id=09a6c8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6c8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a6c8aa')) {
      api.createRecord('09a6c8aa', component.options)
    } else {
      api.reload('09a6c8aa', component.options)
    }
    module.hot.accept("./DfTelephoneField.vue?vue&type=template&id=09a6c8aa&scoped=true&", function () {
      api.rerender('09a6c8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfTelephoneField.vue"
export default component.exports